import { Account } from "./Account";
import { Dashboard } from "./Dashboard";
import { Session } from "./Session";
import { SignIn } from "./SignIn";
import { SignOut } from "./SignOut";

export const Screens = {
  Account,
  Dashboard,
  Session,
  SignIn,
  SignOut,
};
